import { Center, Loader, useMantineTheme } from '@mantine/core';
import type { ButtonProps } from '@repo/foundations';
import { Button } from '@repo/foundations';
import { memo } from 'react';

export const AuthButton = memo(
	({
		children,
		loading,
		...props
	}: {
		children: React.ReactNode;
		loading?: boolean;
		disabled?: boolean;
		onClick?: () => void;
	} & ButtonProps) => {
		const theme = useMantineTheme();
		return (
			<Button variant="default" size="lg" h={44} {...props}>
				{loading ? (
					<Center>
						<Loader
							color={theme.other.getColor('border/transparent/default')}
							size="sm"
						/>
					</Center>
				) : (
					children
				)}
			</Button>
		);
	}
);
